import { rtkQueryApiServices, rtkQueryServiceTags } from "../../services/api";

const { CHAT } = rtkQueryServiceTags;

export const chatApis = rtkQueryApiServices.injectEndpoints({
  endpoints: (builder) => ({
    userChats: builder.query({
      query: (params = "") => ({
        url: `/mqtt/subscriptions/user_subscriptions/`,
        params
      }),
      providesTags: [CHAT],
    }),
    sendMessage: builder.mutation({
      query: (params = "") => ({
        url: `/mqtt/message/`,
        method: "POST",
        body: params.body,
      }),
      invalidatesTags: [CHAT],
    }),
    sendMessageAttachment: builder.mutation({
      query: (params = "") => ({
        url: `/mqtt/message-attachments/`,
        method: "POST",
        body: params.body,
      }),
      invalidatesTags: [CHAT],
    }),
    getMessages: builder.query({
      query: (params = "") => ({
        url: `/mqtt/message/topic/${params.topic}/`,
      }),
    }),
    getPrograms: builder.query({
      query: (params = "") => ({
        url: `/programs`,
        params,
      }),
    }),
     getFilterCount: builder.query({
      query: (params = "") => ({
        url: `/mqtt/subscriptions/user_subscription_count/`,
        params,
      }),
      providesTags: ['Counts']
    }),
    getProgramMembers: builder.query({
      query: ({id,...rest}) => ({
        url: `programs/${id}/program-users`,
        // method: "POST",
        params:rest
      }),
    }),
    createRoomTopic: builder.mutation({
      query: (body) => ({
        url: `/mqtt/topics/`,
        method: "POST",
        body,
      }),
      // invalidatesTags: [CHAT],
    }),
    subscribeUsersIntoNewRoom: builder.mutation({
      query: ({ user_ids, topic_id }) => ({
        url: `/mqtt/subscriptions/add_participants/`,
        method: "POST",
        body: { user_ids, topic_id },
      }),
      invalidatesTags: [CHAT],
    }),
    chatNotification: builder.query({
      query: (params = "") => ({
        url: `/mqtt/subscriptions/get-notitification-topic/`,
        method: "GET",
        params,
      }),
    }),
    sendMessageStatus: builder.mutation({
      query: (params = "") => ({
        url: `/mqtt/message-tracker/mark-as-read/`,
        method: "PUT",
        body: {
          topic_id: params.topic_id,
        },
      }),
    }),
  }),
});

export const {
  useUserChatsQuery,
  useSendMessageMutation,
  useSendMessageAttachmentMutation,
  useGetMessagesQuery,
  useGetProgramMembersQuery,
  useGetProgramsQuery,
  useGetFilterCountQuery,
  useCreateRoomTopicMutation,
  useSubscribeUsersIntoNewRoomMutation,
  useChatNotificationQuery,
  useSendMessageStatusMutation,
} = chatApis;
